import React from "react";

const INDUSTRIES = [
  "Law Firms",
  "Restaurants & Event Venues",
  "Real Estate Teams",
  "Med Spas & Aesthetics",
  "HVAC & Contractors",
  "Financial Advisors",
  "Dentists & Doctors",
  "Insurance Agencies",
  "Home Service Businesses",
  "Coaches & Consultants",
  "Salons & Barbershops",
  "Property Management",
];

export default function Industries() {
  return (
    <section data-testid="industries-section" className="bg-white fs-section border-y border-black/5">
      <div className="fs-container">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-[#C9A84C]" />
            <span className="fs-tag">Who This Is For</span>
          </div>
          <h2 className="font-display text-4xl md:text-6xl uppercase tracking-[0.03em] leading-[0.95] text-[#0A0F1E]">
            If One Customer Is Worth<br />
            <span className="text-[#C9A84C]">$1,000+</span> to Your Business…
          </h2>
          <p className="mt-6 text-lg text-[#0F172A]/70 max-w-2xl leading-relaxed">
            This pays for itself the moment it books your first appointment.
            These are the businesses where our agent changes everything:
          </p>
        </div>

        <div className="mt-12 flex flex-wrap gap-3">
          {INDUSTRIES.map((label, i) => (
            <span
              key={i}
              data-testid={`industry-pill-${i}`}
              className="px-5 py-2.5 rounded-full bg-[#0A0F1E] text-sm text-white/90 border border-transparent hover:border-[#C9A84C] hover:text-white transition-colors cursor-default"
            >
              {label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
